import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    tableNo: '',       // 当前桌号
    tableName: '',
    cart: []           // [{dishId, dishName, dishImage, price, quantity, remark}]
  },
  getters: {
    cartTotal: state => state.cart.reduce((sum, item) => sum + item.price * item.quantity, 0),
    cartCount: state => state.cart.reduce((sum, item) => sum + item.quantity, 0)
  },
  mutations: {
    SET_TABLE(state, { tableNo, tableName }) {
      state.tableNo = tableNo
      state.tableName = tableName
    },
    ADD_TO_CART(state, dish) {
      const found = state.cart.find(i => i.dishId === dish.dishId)
      if (found) {
        found.quantity++
      } else {
        state.cart.push({ ...dish, quantity: 1 })
      }
    },
    REMOVE_FROM_CART(state, dishId) {
      const idx = state.cart.findIndex(i => i.dishId === dishId)
      if (idx !== -1) {
        if (state.cart[idx].quantity > 1) {
          state.cart[idx].quantity--
        } else {
          state.cart.splice(idx, 1)
        }
      }
    },
    CLEAR_CART(state) {
      state.cart = []
    }
  }
})
